export { parseSingleCurlyBraceClozePromptMarkup } from "./util/parseClozeMarkup";
export var TaskSpecType;
(function (TaskSpecType) {
    TaskSpecType["Memory"] = "memory";
    // In the future: Generic, Custom, etc
})(TaskSpecType || (TaskSpecType = {}));
export const mainTaskComponentID = "main";
export var TaskContentType;
(function (TaskContentType) {
    TaskContentType["QA"] = "qa";
    TaskContentType["Cloze"] = "cloze";
    TaskContentType["Plain"] = "plain";
})(TaskContentType || (TaskContentType = {}));
//# sourceMappingURL=task.js.map